import React from "react";
import GradeSessionsPage from "@/components/GradeSessionsPage";

const AGENDA = [
  { time: "7:30-8:30 am", label: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment" },
  { time: "8:30-9:15 am", label: "Keynote Speaker" },
  { time: "9:30-10:30 am", label: "Session 1" },
  { time: "10:45-11:45 am", label: "Session 2" },
  { time: "11:45 am - 1 pm", label: "Lunch" },
  { time: "1:15-2:15 pm", label: "Session 3" },
];

const KEYNOTE_SPEAKER = {
  name: "Tiffany N. Willis",
  title: `Director, Virginia Tech Office of Undergraduate Academic Integrity
Founder, AIM & Integrity, LLC`,
  photo: "/images/willis.png",
  bio: `Tiffany Willis serves as the Director for the Virginia Tech Office of Undergraduate Academic Integrity, where she leads efforts to promote transparency, responsibility, and ethical practices among students and faculty. She has co-chaired multiple AI-focused groups addressing academic integrity, IT governance, technology and learning strategies, and curriculum design. She is also the founder of AIM & Integrity, LLC, a consulting organization that supports K–12 and higher education institutions in navigating the evolving landscape of artificial intelligence. Through her AIMI Framework™ (Awareness, Implementation, Management, Impact), she provides practical strategies for responsible AI integration centered on equity and integrity. Her work includes faculty and staff training, student AI literacy programming, policy development, and resources that support ethical decision-making. Tiffany holds advanced degrees from Vanderbilt University and the University of West Alabama and is committed to fostering environments where ethical AI use and academic integrity are expected and supported.`,
};

const SESSIONS = [
  {
    title: "AI in the Elementary Classroom",
    description: `Elementary teachers will explore practical and responsible ways to integrate AI into instruction and planning. Participants will engage with tools to support differentiation, student engagement, and instructional creativity across elementary content areas.`,
  },
  {
    title: "MagicSchool AI",
    description: `This interactive session provides educators with hands-on experience using MagicSchool AI to support daily classroom instruction and streamline teacher workflows. Participants will explore a variety of educator-focused AI tools designed to assist with lesson planning, instructional differentiation, assessment creation, rubric development, parent communication, and classroom engagement. Teachers will learn practical strategies for using AI to save time while maintaining high-quality, student-centered instruction.

Throughout the workshop, participants will have the opportunity to practice using MagicSchool AI tools in real classroom scenarios and create resources they can immediately implement in their classrooms. The session will also highlight responsible AI use, best practices for reviewing AI-generated content, and ways to align AI-supported instruction with district expectations and curriculum goals. By the end of the session, teachers will leave with practical tools and strategies to increase efficiency, personalize learning, and support student success.`,
  },
  {
    title: "Social Studies Curriculum Overview",
    description: `K-2 teachers will explore the Cengage social studies curriculum with a focus on standards alignment, lesson design, and instructional pacing. Participants will examine strategies that support literacy, inquiry, and student engagement in history, civics, geography, and economics.`,
  },
];

export default function K2Sessions() {
  return (
    <GradeSessionsPage
      testId="k2-sessions-page"
      title="K-2 District PD Information"
      barColor="#145261"
      gradeBand="k2"
      location={{
        name: "Wenonah High School",
        address: "2800 Wilson Rd SW, Birmingham, AL 35221",
      }}
      agenda={AGENDA}
      keynoteSpeaker={KEYNOTE_SPEAKER}
      sessionsList={SESSIONS}
      accessCode="KVS8-SKXP-JTMHH"
    />
  );
}
